import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-entitie',
  templateUrl: './edit-entitie.component.html',
  styleUrls: ['./edit-entitie.component.scss']
})
export class EditEntitieComponent {

}
